import classes from './Button.module.css';

const Button = (props) => {
    return(
        <button onClick={props.clickhandler} className={classes.button} type={props.type ===undefined ? 'button' : props.type } disabled={props.disabled} style={props.cs} >{props.children}</button>
    )
}

export default Button;